import Card from "../Card"
import { useAppSelector } from "../../redux/store/hooks"
import {
    selectDashboardDataSeverities,
    selectDashboardSelectedValueType
} from "../../redux/ProfessionalDashboard"
import SmallHeadingComponent from "../SmallHeadingComponent"
import {
    GetPatientOverviewSeveritiesResponsePayload,
    getTrendAnalysisColor,
    TrendAnalysisResult,
    ValueType
} from "pokal_api"
import notNull from "../../util/notNull"
import PokalColorConverter from "../../util/PokalColorConverter"
import trendAnalysisToString from "../../util/trendAnalysisToString"
import { useEffect, useState } from "react"
import {
    hidePatientDetailViewDataTrend,
    mockPhqValueTypeUsed,
    mockSeveritiesUsed,
    mockSleepValueTypeUsed,
    selectOnboardingIsRunningState,
    selectOnboardingStep
} from "../../redux/Onboarding"
import mockPatientSeverities from "../../onboarding/mock/mockPatientSeverities"
import DocumentationComponent from "../DocumentationComponent"
import { TREND_DOC } from "../../documentation/Documentation"

function TrendEstimationView() {
    const fetchedSelectedValueType = useAppSelector(
        selectDashboardSelectedValueType
    )
    const fetchedDataSeverities = useAppSelector(selectDashboardDataSeverities)

    const [dataSeverities, setDataSeverities] =
        useState<GetPatientOverviewSeveritiesResponsePayload | null>(null)
    const [selectedValue, setSelectedValue] = useState<ValueType | null>(null)
    const [trend, setTrend] = useState<TrendAnalysisResult>(null)

    useEffect(() => {
        if (notNull(dataSeverities) && notNull(selectedValue)) {
            setTrend(dataSeverities.relative[selectedValue])
        }
    }, [selectedValue, dataSeverities])

    const step = useAppSelector(selectOnboardingStep)
    const running = useAppSelector(selectOnboardingIsRunningState)
    useEffect(() => {
        if (mockSeveritiesUsed(running, step)) {
            setDataSeverities(mockPatientSeverities())
            if (mockPhqValueTypeUsed(running, step)) {
                setSelectedValue(ValueType.PHQUESTIONNAIRE)
            }
            if (mockSleepValueTypeUsed(running, step)) {
                setSelectedValue(ValueType.SLEEP_DURATION)
            }
        } else {
            setDataSeverities(fetchedDataSeverities)
            setSelectedValue(fetchedSelectedValueType)
        }
    }, [running, step, fetchedDataSeverities, fetchedSelectedValueType])

    return (
        <>
            {notNull(selectedValue) && (
                <Card
                    blur={hidePatientDetailViewDataTrend(running, step)}
                    outline={
                        notNull(trend)
                            ? PokalColorConverter.toTopBorder(
                                  getTrendAnalysisColor(trend)
                              )
                            : undefined
                    }
                    width={"100%"}
                    fill={true}>
                    <div className={"flex flex-col space-y-4"}>
                        <SmallHeadingComponent>
                            Trend-Einschätzung
                        </SmallHeadingComponent>
                        {notNull(trend) ? (
                            <div>
                                Ermittelter{" "}
                                <DocumentationComponent
                                    documentation={TREND_DOC}>
                                    Trend
                                </DocumentationComponent>
                                : {trendAnalysisToString(trend)}
                            </div>
                        ) : (
                            <>
                                <div>
                                    Aufgrund fehlender Daten keine
                                    <DocumentationComponent
                                        documentation={TREND_DOC}>
                                        Trendermittlung
                                    </DocumentationComponent>{" "}
                                    möglich
                                </div>
                            </>
                        )}
                    </div>
                </Card>
            )}
        </>
    )
}

export default TrendEstimationView
